<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-single-select-edit-control [formControlName]="'POSTAL_ADDRESS'"
                                                                [(ngModel)]="model.data.POSTAL_ADDRESS"
                                                                [allowClearSelectionOption]="false">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="'true'"
                                                           label="wbo.acc-item-stmt-report.option.address.postal"></wbo-select-option>
                                        <wbo-select-option [value]="'false'"
                                                           label="wbo.acc-item-stmt-report.option.address.home"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="showChargesAfter" [(ngModel)]="model.data.showChargesAfter"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-detail-report-criteria></wbo-detail-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-account-report-selection></wbo-account-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
